export default "__VITE_ASSET__Dsln0r$t__"